function loader() {
    const loading = document.body.classList.contains('loading');
    if (loading) {
      document.body.classList.add('loading--finished');
      setTimeout(function () {
        document.body.classList.remove('loading--finished');
        document.body.classList.remove('loading');
        document.dispatchEvent(new CustomEvent('bodyLoadingFinished'));
      }, 120);
    }
}
  
if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', loader);
    } else {
        loader();
    }